import React from "react"
import styled, { ThemeProps, ThemedStyledProps } from "styled-components"
import typography from "../../utils/typography"
import { textIn } from "../reveal"

const inter = typography.options.bodyFontFamily.join();

const Button = styled.button`
  padding: .375rem .75rem;
  margin: 0;
  margin-right: .75rem;
  font-size: .875rem;
  font-weight: 600;
  line-height: calc(18/14);
  text-transform: uppercase;
  letter-spacing: 1px;
  background-color: transparent;
  border: 1px solid;
  color: ${props => props.theme.colors.primaryColor};
  transition: 300ms ease-in-out background-color, 250ms ease-in box-shadow;
  cursor: pointer;
  box-shadow: 0 0 ${props => props.theme.colors.background}, 3px 3px;

  &:hover {
    background-color: ${props => props.theme.colors.primaryColor};
    box-shadow: 2px 2px, 3px 3px ${props => props.theme.colors.primaryColor};
    border-color: ${props => props.theme.colors.primaryColor};
    color: ${props => props.theme.colors.background};
  }

  &:active {
    background-color: ${props => props.theme.colors.formBackground};
    box-shadow: 0 0;
    color: ${props => props.theme.colors.primaryColor};
    transform: translate3d(2px, 2px, 0);
  }
`

const BasicButton = ({ handleClick, children }) => (
  <Button onClick={handleClick}>
    {children}
  </Button>
)

export default BasicButton
